import { httpClient } from '../api/http-client';

export interface AuditoriaRecord {
  id: string;
  usuarioId: string | null;
  emailUsuario: string | null;
  nombreUsuario: string | null;
  accion: string;
  modulo: string | null;
  entidad: string | null;
  entidadId: string | null;
  datosAnteriores: Record<string, unknown> | null;
  datosNuevos: Record<string, unknown> | null;
  ipAddress: string | null;
  userAgent: string | null;
  endpoint: string | null;
  metodoHttp: string | null;
  resultado: string | null;
  mensajeError: string | null;
  creadoEn: string;
}

export interface AuditoriaMeta {
  total: number;
  pagina: number;
  limite: number;
  totalPaginas: number;
}

export interface ListarAuditoriaResponse {
  success: boolean;
  data: AuditoriaRecord[];
  meta: AuditoriaMeta;
}

export interface FiltrosAuditoria {
  usuarioId?: string;
  emailUsuario?: string;
  accion?: string;
  modulo?: string;
  entidad?: string;
  entidadId?: string;
  resultado?: string;
  fechaDesde?: string;
  fechaHasta?: string;
  pagina?: number;
  limite?: number;
  orden?: 'asc' | 'desc';
}

export interface UltimaModificacionResponse {
  success: boolean;
  data: AuditoriaRecord | null;
}

export class AuditoriaService {
  private static readonly BASE_PATH = '/auditoria';

  static async listar(filtros: FiltrosAuditoria = {}): Promise<ListarAuditoriaResponse> {
    const params = new URLSearchParams();
    if (filtros.pagina) params.append('pagina', String(filtros.pagina));
    if (filtros.limite) params.append('limite', String(filtros.limite));
    if (filtros.usuarioId) params.append('usuarioId', filtros.usuarioId);
    if (filtros.emailUsuario) params.append('emailUsuario', filtros.emailUsuario);
    if (filtros.accion) params.append('accion', filtros.accion);
    if (filtros.modulo) params.append('modulo', filtros.modulo);
    if (filtros.entidad) params.append('entidad', filtros.entidad);
    if (filtros.entidadId) params.append('entidadId', filtros.entidadId);
    if (filtros.resultado) params.append('resultado', filtros.resultado);
    if (filtros.fechaDesde) params.append('fechaDesde', filtros.fechaDesde);
    if (filtros.fechaHasta) params.append('fechaHasta', filtros.fechaHasta);
    if (filtros.orden) params.append('orden', filtros.orden);

    const query = params.toString();
    const response = await httpClient.get<ListarAuditoriaResponse>(
      `${this.BASE_PATH}${query ? `?${query}` : ''}`
    );
    return response.data;
  }

  static async obtenerUltimaModificacion(entidadId: string, entidad: string): Promise<UltimaModificacionResponse> {
    const params = new URLSearchParams();
    params.append('entidadId', entidadId);
    params.append('entidad', entidad);
    const response = await httpClient.get<UltimaModificacionResponse>(
      `${this.BASE_PATH}/last-modification?${params.toString()}`
    );
    return response.data;
  }
}
